import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Cancel = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.43926 5.43907C5.68333 5.19499 6.07906 5.19499 6.32314 5.43907L8.00005 7.11598L9.67695 5.43907C9.92103 5.195 10.3168 5.195 10.5608 5.43907C10.8049 5.68315 10.8049 6.07888 10.5608 6.32296L8.88393 7.99986L10.5611 9.67705C10.8052 9.92112 10.8052 10.3169 10.5611 10.5609C10.317 10.805 9.92131 10.805 9.67723 10.5609L8.00005 8.88375L6.32286 10.5609C6.07878 10.805 5.68306 10.805 5.43898 10.5609C5.1949 10.3169 5.1949 9.92113 5.43898 9.67705L7.11617 7.99986L5.43926 6.32295C5.19518 6.07888 5.19518 5.68315 5.43926 5.43907Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 12.75C10.6234 12.75 12.75 10.6234 12.75 8C12.75 5.37665 10.6234 3.25 8 3.25C5.37665 3.25 3.25 5.37665 3.25 8C3.25 10.6234 5.37665 12.75 8 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Cancel;
